import { type Clip } from '@air/api/types';
import { ClipUtils, isPdfRenderedExtension } from '@air/utils-clips';

import { IMAGE_COMPARISON_CLIP_TYPES, PLAYBACK_COMPARISON_CLIP_TYPES } from '~/constants/assetComparison';

export type AssetComparisonEligibleClip = Pick<Clip, 'assets' | 'ext' | 'status' | 'type'>;

export const isAssetComparisonClipEligible = (clip: AssetComparisonEligibleClip) => {
  if (ClipUtils.isFailed(clip.status) || isPdfRenderedExtension(clip.ext)) {
    return false;
  }

  if (IMAGE_COMPARISON_CLIP_TYPES.has(clip.type)) {
    return Boolean(clip.assets.image || clip.assets.original);
  }

  return PLAYBACK_COMPARISON_CLIP_TYPES.has(clip.type);
};
